import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 30000, // survive backend cold-starts; never hang on "Loading..." forever
});

// Legacy Emergent-storage uploads bundled into the app so they load on any host
// (Render cannot serve /api/files/... — these map to static /assets/ files).
const LEGACY_FILE_MAP = {
  "/api/files/goldenlive/uploads/333e4c45-ab70-4da0-84ae-e5c4dd92379e.jpg": "/assets/logo.jpg",
  "/api/files/goldenlive/uploads/c2dc6581-9a13-42f6-a20b-8f5760af72a8.jpg": "/assets/banner1.jpg",
  "/api/files/goldenlive/uploads/1289a67e-b85e-4d4a-ad0e-8647505f07ca.png": "/assets/banner2.png",
  "/api/files/goldenlive/uploads/fb370318-e7ad-4d06-91a0-44c3b3a4055e.jpeg": "/assets/reseller1.jpeg",
  "/api/files/goldenlive/uploads/98e70edb-e51a-45ba-a661-e58639aedfe3.jpeg": "/assets/agency1.jpeg",
  "/api/files/goldenlive/uploads/2ff419a4-aeb8-4f30-aefc-6e5892df0463.jpeg": "/assets/agency2.jpeg",
  "/api/files/goldenlive/uploads/5ab23c6b-e9b2-4419-9881-83399c3b17c7.jpeg": "/assets/agency3.jpeg",
};

// Resolve a stored image path/url into a full loadable URL.
export function resolveImage(url) {
  if (!url) return "";
  if (LEGACY_FILE_MAP[url]) return LEGACY_FILE_MAP[url];
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}

// Build a WhatsApp deep link. Strips all non-digits from code + number.
export function whatsappLink(countryCode, number, message) {
  const digits = `${countryCode || ""}${number || ""}`.replace(/\D/g, "");
  const base = `https://wa.me/${digits}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
